import { Dialog } from '@headlessui/react'
import { useState } from 'react'
import { XCircleIcon } from '@heroicons/react/solid'

export default function Zoom({ url, alt }) {
  let [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <button onClick={() => setIsOpen(true)}>
        <img src={url} alt={alt} className='w-full' />
      </button>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <Dialog.Panel className="m-auto rounded bg-white relative">

            <img src={url} alt={alt} className='w-full h-full max-h-[90vh] max-w-[90vw]' />

            <Dialog.Title className="text-center py-2">{alt}</Dialog.Title>
            <button className="bg-white font-bold rounded-full flex justify-center items-center h-12 w-12 absolute bottom-6 right-8 hover:bg-black hover:text-white transition" onClick={() => setIsOpen(false)}><XCircleIcon/></button>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  )
}
